<template>
  <el-input-number v-model="sceneZoomPercentValue"
                   class="zoom-scene"
                   :min="0"
                   :max="200"
                   :step="1"
                   @change="handleZoomScene" />
</template>

<script>
import { set } from 'lodash';
import i18n from '@/i18n';
import bus, { EVENTS } from '../report-inspector-scene/bus';

export default {
  name: 'SceneZoomButton',
  props: {
    selectedScene: {
      type: String,
      default: i18n.t('Realogram')
    }
  },
  data() {
    return {
      sceneZoomPercentValue: 40,
      sceneZoomScaleValue: 0.4,
      allScenesZoomScales: {
        realogram: 0.4,
        planogram: 0.4
      }
    };
  },
  computed: {
    getWheelZoomScaleValue() {
      return bus.sceneZoomScaleValue[this.zoomType];
    },
    zoomType() {
      return this.selectedScene === i18n.t('Planogram') ? 'planogram' : 'realogram';
    }
  },
  watch: {
    getWheelZoomScaleValue() {
      this.sceneZoomPercentValue = Math.round(parseFloat(this.getWheelZoomScaleValue).toFixed(2) * 100);
      this.handleZoomScene();
    },
    selectedScene() {
      const selectedSceneZoom = this.selectedScene === i18n.t('Planogram') ? bus.sceneZoomScaleValue.planogram : bus.sceneZoomScaleValue.realogram;
      this.sceneZoomPercentValue = Math.round(parseFloat(selectedSceneZoom).toFixed(2) * 100);
      this.handleZoomScene();
    }
  },
  methods: {
    handleZoomScene() {
      this.sceneZoomScaleValue = this.sceneZoomPercentValue / 100;
      this.updateSelectedSceneZoomValue();
      bus.$emit(EVENTS.ZOOM_BUTTON_CHANGE);
      this.$emit('input', this.allScenesZoomScales);
    },
    updateSelectedSceneZoomValue() {
      set(this.allScenesZoomScales, this.zoomType, this.sceneZoomScaleValue);
      set(bus.sceneZoomScaleValue, this.zoomType, this.sceneZoomScaleValue);
    }
  }
};
</script>

<style lang="scss">
.zoom-scene {
  width: 78px;

  .el-input-number__decrease,
  .el-input-number__increase {
    width: 23px;
    background-color: #fff;
  }

  .el-input-number__decrease {
    border-right: none;
    border-radius: 50px 0 0 50px;
  }

  .el-input-number__increase {
    border-left: none;
    border-radius: 0 50px 50px 0;
  }

  .el-input {
    input {
      padding: 0 16px;
      border: 1px solid #e2e2e2;
      border-radius: 50px;
    }
  }
}
</style>
